import React, { memo } from 'react'

import { BaseProviders } from '../../shared/providers'
import { AppAnalyticsProvider } from './AppAnalyticsProvider'
import { AppApolloProvider } from './AppApolloProvider'
import { AppAuthProvider } from './AppAuthProvider'
import { AppErrorBoundaryProvider } from './AppErrorBoundaryProvider'
import { AppI18nProvider } from './AppI18nProvider'
import { AppProvidersPropertiesInterface } from './AppProviders.types'
import { AppRestQueryClientProvider } from './AppRestQueryClientProvider'
import { AppRouterProvider } from './AppRouterProvider'
import { AppTrackerProvider } from './AppTrackerProvider'

export const AppProviders = memo(({ children, direction }: AppProvidersPropertiesInterface) => (
  <BaseProviders direction={direction}>
    <AppRouterProvider>
      <AppRestQueryClientProvider>
        <AppApolloProvider>
          <AppAuthProvider>
            <AppI18nProvider>
              <AppAnalyticsProvider>
                <AppTrackerProvider>
                  <AppErrorBoundaryProvider>{children}</AppErrorBoundaryProvider>
                </AppTrackerProvider>
              </AppAnalyticsProvider>
            </AppI18nProvider>
          </AppAuthProvider>
        </AppApolloProvider>
      </AppRestQueryClientProvider>
    </AppRouterProvider>
  </BaseProviders>
))
AppProviders.displayName = 'AppProviders'
